module.exports = __webpack_public_path__ + "img/rock-big-19.81e87122.png";